import React from "react";
import { Dialog } from "@headlessui/react";
import { ImageOff, X } from "lucide-react";
import { resolveAssetUrl } from "../../../utils/assetUrl";

export default function ProductImagePreviewModal({ open, onClose, product }) {
  const uploadsBaseURL = `${process.env.REACT_APP_API_URL}/uploads`;
  const imageUrl = resolveAssetUrl(
    product?.image
      || (product?.image_url
        ? `${uploadsBaseURL}/${product.image_url}`
        : null)
  );

  return (
    <Dialog open={open} onClose={onClose} className="fixed inset-0 z-[120]">
      <div className="fixed inset-0 bg-slate-950/55 backdrop-blur-sm" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="relative w-full max-w-3xl overflow-hidden rounded-[28px] border border-white/15 bg-slate-950 shadow-[0_30px_80px_rgba(15,23,42,0.45)]">
          <button
            onClick={onClose}
            className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-slate-500 shadow-sm transition hover:text-slate-900"
            aria-label="Close product image preview"
          >
            <X className="h-5 w-5" />
          </button>

          <div className="flex min-h-[420px] items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.12),_transparent_45%)] p-6 sm:p-8">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={product?.name ? `${product.name} preview` : "Product preview"}
                className="max-h-[78vh] w-auto max-w-full rounded-3xl object-contain shadow-[0_24px_60px_rgba(15,23,42,0.45)]"
              />
            ) : (
              <div className="flex flex-col items-center justify-center gap-4 rounded-3xl border border-white/10 bg-white/5 px-10 py-14 text-center text-slate-300">
                <ImageOff className="h-16 w-16 text-slate-500" />
                <div>
                  <Dialog.Title className="text-lg font-semibold text-white">
                    No product image
                  </Dialog.Title>
                  <p className="mt-1 text-sm text-slate-400">
                    {product?.name || "This product"} does not have an uploaded image yet.
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="border-t border-white/10 bg-slate-900/80 px-6 py-4 text-sm text-slate-200 sm:px-8">
            <p className="font-semibold text-white">{product?.name || "Unknown Product"}</p>
            <p className="mt-1 text-slate-400">{product?.product_code || "No product code available"}</p>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
